import React from "react";
import api from "utils/api";
import "./Others.scss";
import Loader from "Components/Loader";
import ProtectiveFactorChild from "./ProtectiveFactorChild";
import { Empty } from "antd";

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resultObjects: [],
    };
  }

  componentDidMount() {
    this.getProtectiveFactorDetails();
  }

  getProtectiveFactorDetails() {
    this.setState({ isLoading: true });
    api
      .get_protective_factor_summary_list({
        patient_id: this.props.data?.patient_id,
        type: this.props.data?.user_type,
      })
      .then((res) => {
        this.setState({
          resultObjects: res.data?.data?.results,
          isLoading: false,
        });
      })
      .catch((err) => {});
  }

  render() {
    return (
      <>
        {this.state.isLoading ? (
          <Loader />
        ) : (
          <div className="mhe-wrapper-container">
            <div className="mhe-header">
              <div>Protective Factors</div>
            </div>

            <div className="mhe-content">
              {this.state.resultObjects.length == 0 ? (
                <Empty
                  description={"No Data"}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              ) : (
                (this.state.resultObjects || []).map((data, index) => {
                  return (
                    <React.Fragment key={index}>
                      {data.is_completed ? (
                        <ProtectiveFactorChild data={data} />
                      ) : null}
                    </React.Fragment>
                  );
                })
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}
